import { HttpClientModule } from "@angular/common/http";
import { NgModule } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { CommonComponentsModule } from "components/common/common-components.module";
import { ComponentsModule } from "components/components.module";
import { IonicPageModule } from "ionic-angular";
import { NavigationModule } from "navigation/navigation.module";
import { PatientReportsPage } from "./patient-reports";
import { PlanOfCareHistoryComponent } from "./reports/plan-of-care-history";

@NgModule({
  declarations: [PatientReportsPage, PlanOfCareHistoryComponent],
  imports: [
    IonicPageModule.forChild(PatientReportsPage),
    TranslateModule.forChild(),
    HttpClientModule,
    CommonComponentsModule,
    NavigationModule,
    ComponentsModule,
  ],
})
export class PatientReportsModule {}



// WEBPACK FOOTER //
// ./src/pages/patient-chart/patient-reports/patient-reports.module.ts